// Crops an image file down to the pixel area react-easy-crop reports,
// via an offscreen canvas, and hands back a File ready to attach to the
// upload form data — same filename/type as the source.
export function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener('load', () => resolve(img));
    img.addEventListener('error', reject);
    img.setAttribute('crossOrigin', 'anonymous');
    img.src = src;
  });
}

export async function getCroppedImageFile(imageSrc, croppedAreaPixels, fileName, mimeType) {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(
    image,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    croppedAreaPixels.width,
    croppedAreaPixels.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (!blob) { reject(new Error('Could not crop this image.')); return; }
      resolve(new File([blob], fileName, { type: mimeType || 'image/jpeg' }));
    }, mimeType || 'image/jpeg', 0.92);
  });
}
